import React, { useEffect, useMemo, useState } from 'react';

const inputStyle = {
  width: '100%',
  padding: '7px 10px',
  borderRadius: 7,
  border: '1px solid var(--border)',
  fontSize: 12,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  boxSizing: 'border-box',
  outline: 'none',
};
const labelStyle = { fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', marginBottom: 3, display: 'block' };
const responsiveTwoCol = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(220px, 100%), 1fr))', gap: 10, minWidth: 0 };
const sectionBox = { background: 'var(--bg-subtle)', borderRadius: 10, padding: '12px 14px', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 10, minWidth: 0, boxSizing: 'border-box' };
const dropStyle = { position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 10, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, maxHeight: 160, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.12)' };
const dropItemStyle = { padding: '6px 10px', fontSize: 12, cursor: 'pointer', color: 'var(--text)' };

export default function PayrollEmployeeBankSection({ form, setForm, bankCodes = [] }) {
  const [bankQuery, setBankQuery] = useState(form.bank_name || '');
  const [showBankDrop, setShowBankDrop] = useState(false);

  useEffect(() => {
    setBankQuery(form.bank_name || '');
  }, [form.bank_name]);

  const filteredBanks = useMemo(() => {
    if (!bankQuery) return bankCodes;
    const q = bankQuery.toLowerCase();
    return bankCodes.filter((b) => `${b.code} ${b.name}`.toLowerCase().includes(q));
  }, [bankQuery, bankCodes]);

  return (
    <div style={sectionBox}>
      <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--text-sub)' }}>계좌 정보</div>
      <div style={responsiveTwoCol}>
        <div style={{ position: 'relative' }}>
          <label style={labelStyle}>은행명</label>
          <input
            style={inputStyle}
            value={bankQuery}
            onChange={(e) => { setBankQuery(e.target.value); setShowBankDrop(true); setForm({ ...form, bank_name: e.target.value }); }}
            onFocus={() => setShowBankDrop(true)}
            onBlur={() => setTimeout(() => setShowBankDrop(false), 150)}
            placeholder="은행 검색 (코드 또는 이름)"
          />
          {showBankDrop && filteredBanks.length > 0 && (
            <div style={dropStyle}>
              {filteredBanks.map((b) => (
                <div key={b.id} style={dropItemStyle}
                  onMouseDown={() => {
                    setBankQuery(b.name);
                    setForm({ ...form, bank_name: b.name });
                    setShowBankDrop(false);
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bg-subtle)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--bg-card)'; }}
                >
                  <span style={{ fontWeight: 700, marginRight: 6 }}>{b.code}</span>{b.name}
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <label style={labelStyle}>계좌번호</label>
          <input style={inputStyle} value={form.bank_account} onChange={(e) => setForm({ ...form, bank_account: e.target.value })} />
        </div>
      </div>
      <div style={responsiveTwoCol}>
        <div>
          <label style={labelStyle}>계좌 적용일</label>
          <input
            style={inputStyle}
            type="date"
            value={form.bank_effective_from || ''}
            onChange={(e) => setForm({ ...form, bank_effective_from: e.target.value })}
          />
        </div>
        <div>
          <label style={labelStyle}>계좌 변경 사유</label>
          <input
            style={inputStyle}
            value={form.bank_change_reason || ''}
            onChange={(e) => setForm({ ...form, bank_change_reason: e.target.value })}
            placeholder="예: 급여계좌 변경"
          />
        </div>
      </div>
    </div>
  );
}
